import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Persisted view-mode + session ordering for the cabinet Time Off list,
 * mirroring the CRM list stores (CLAUDE.md §2.3). */
export type TimeOffViewMode = 'table' | 'list' | 'cards' | 'grouped';

interface TimeOffUiState {
  view: TimeOffViewMode;
  setView: (view: TimeOffViewMode) => void;
  /** DRF OrderingFilter value (e.g. `-start_date`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useTimeOffUi = create<TimeOffUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'cabinet.time-off:ui',
      // Only the view mode is durable; ordering resets on refresh.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
